<template>
  <div class="base-card" :class='`${type}`'>
    <div class="base-card-title" :class='`${type}`'>
      <span class="type">{{title}}</span>
      <span class="description">{{description}}</span>
    </div>
    <div class="base-card-description" :class='`${type}`'>
      <Pricing v-if="type === 'business'"/>
      <div class="base-card-pricing" v-else>
        <div class="base-card-pricing-block">
          <div class="from" v-if="type === 'enterprise'">from</div>
          <span class="dollar-wrap">
            <img src="https://sirvwebsite.sirv.com/assets/dollar.svg"></span>
          <span class="cost">{{price}}</span>
          <span class="per-time"><span class="per-time-separator">/</span><span class="per-time-value">month</span></span>
        </div>
        <div class="storage">{{storage}} storage</div>
      </div>
      <div class="base-card-action" :class="`${type}`">
        <a :href="buttonLink" class="btn-card">{{buttonText}}</a>
      </div>
      <div class="base-card-features">
        <div class="base-card-features-title">{{featuresTitle}}</div>
        <ul class="base-card-features-list">
          <li
            v-for="(feature, key) in features"
            :key="key"
          >
            <span class="before" style="background-image: url(https://sirvwebsite.sirv.com/assets/check.svg)"></span>
            {{feature.title}}
            <Hint v-if="feature.hint" :feature="feature" />
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>
<script>
import Pricing from '@/components/Pricing'
import Hint from '@/components/Hint'
export default {
  name: 'baseCard',
  components: { Pricing, Hint },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String
    },
    type: {
      type: String,
      default: 'unknown'
    },
    price: {
      type: Number,
      default: 0
    },
    storage: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: '#'
    },
    buttonText: {
      type: String,
      default: ''
    },
    featuresTitle: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="scss" scoped>
.base-card {
  width: 100%;
  max-width: 340px;
  min-height: 930px;
  border-radius: 8px;
  &.business {
    max-width: 446px;
  }
}
.base-card-title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  //width: 100%;
  min-height: 160px;
  padding: 20px 25px;
  background-color: #B5BDC8;
  .type {
    font-weight: normal;
    font-size: 40px;
    line-height: 1.5;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 10px;
  }
  &.unknown {
    background-color: #B5BDC8;
  }
  &.free {
    background-color: #B5BDC8;
    border-top-left-radius: 8px;
  }
  &.business {
    background-color: #327BBA;
    min-height: 194px;
    margin-top: -20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .type {
      font-weight: 600;
    }
  }
  &.enterprise {
    background-color: #2f363f;
    border-top-right-radius: 8px;
  }

  .description {
    font-size: 16px;
    line-height: 1.25;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    max-width: 220px;
    font-weight: 400;
  }
}
.base-card-description {
  min-height: 775px;
  padding: 30px;
  &.free {
    border-bottom-left-radius: 8px;
    border-left: 1px solid rgba(47, 54, 63, 0.2);
    border-bottom: 1px solid rgba(47, 54, 63, 0.2);
  }
  &.business {
    box-shadow: 0px 16px 16px rgba(50, 123, 186, 0.08), 0px 48px 80px rgba(50, 123, 186, 0.16);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  &.enterprise {
    border-bottom-right-radius: 8px;
    border-right: 1px solid rgba(47, 54, 63, 0.2);
    border-bottom: 1px solid rgba(47, 54, 63, 0.2);
  }
}
.base-card-pricing {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 268px;
  &-block {
    display: flex;
    align-items: center;
    position: relative;
  }
  .from {
    color: #BBBFC5;
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }

  .dollar-wrap {
    display: flex;
    margin-right: 5px;
  }
  .cost {
    font-size: 48px;
    line-height: 1.2;
    color: #2F363F;
  }
  .per-time {
    font-size: 20px;
    margin-left: 5px;
    margin-bottom: -18px;
    position: relative;
    line-height: 1;
    &-separator {
      bottom: 2px;
      position: relative;
    }
    &-value {
      position: relative;
      bottom: -2px;
    }
  }
  .storage {
    position: relative;
    bottom: -35px;
    font-size: 24px;
  }
}
.base-card-action {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  .btn-card {
    padding: 10px 20px;
    font-size: 16px;
    letter-spacing: .2px;
    text-decoration: none;
    border: 1px solid #327BBA;
    border-radius: 100px;
    transition: opacity .5s ease;
    &:hover{
      opacity: .8;
    }
  }
  &.business {
    padding-top: 7px;
    .btn-card {
      background-color: #327BBA;
      color: #fff;
    }
  }
  @media only screen and (min-width : 1060px) {
    .btn-card {
      padding: 10px 60px;
      font-size: 20px;
    }
  }
}
.base-card-features {
  padding-top: 40px;
  &-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 1.6;
    color: #2F363F;
    margin-bottom: 15px;
  }
  &-list {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1.75;
      color: #2F363F;
      font-weight: 400;
      margin-left: 0;
      .before {
        width: 17px;
        height: 12px;
        background-repeat: no-repeat;
        background-size: cover;
        margin-right: 10px;
      }
    }
  }
  @media only screen and (min-width : 860px) {
    &-list {
      li {
        font-size: 15px;
        line-height: 2;
      }
    }
  }
  @media only screen and (min-width : 1024px) {
    &-list {
      li {
        font-size: 16px;
        line-height: 2;
      }
    }
  }
}
</style>
